<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    disabled
                    outlined
                    dense
                    hide-details
                    background-color="white">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    background-color="white">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-textarea
                    label="Description"
                    v-model="form.description"
                    outlined
                    dense
                    hide-details="auto"
                    background-color="white">
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations';
export default {
    props: {
        value: Object
    },  
    name: "WarehouseForm",
    data() {
        return {
            form: {
                code: "",
                name: "",
                description: ""
            }        
        }
    },
    methods: {
        isRequired,
        validate() {
            return this.$refs.form.validate()
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form});
            }
        }
    },
    mounted() {
        this.form = { ...this.form, ...this.value}
    }
}
</script>

<style>

</style>